const ConditionShowRadioButton = Vue.extend({
  props: {
    field: {
      type: Skylark.App.Model.Field.RadioButton,
      required: true
    },
    judgements: {
      type: Object,
      required: true
    }
  },

  computed: {
    judgementOptions: function() {
      return _.map((this.judgements.inclusion?.in || []), (option_id) => {
        if (option_id === 0) {
          return this.field.otherOption;
        } else {
          return _.find(this.field.options, (option) => option.id === option_id);
        }
      });
    }
  },

  template: `
    <div class="options">
      <div class="option-item readonly"
           v-for='option in judgementOptions'
           :key='option.id'>
        <input type="checkbox" hidden='true' checked='true' />
        <i class="slp-circle-o"></i>
        <div class="option-label">{{ option.label }}</div>
      </div>
    </div>
  `
});

export default ConditionShowRadioButton;
